import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SelectField from 'components/forms/selectField/SelectField';
import { AirbnbGuestRequirements } from 'models/AirbnbGuestRequirements';
import { BOOKING_TYPES } from 'models/BookingType';

const optionsByBookingType: Record<string, AirbnbGuestRequirements[]> = {
  [BOOKING_TYPES.BOOKING_REQUEST]: [AirbnbGuestRequirements.OFF],
  [BOOKING_TYPES.INSTANT_BOOKING]: [
    AirbnbGuestRequirements.EVERYONE,
    AirbnbGuestRequirements.WELL_REVIEWED_GUESTS,
  ],
};

const GuestRequirementsField = () => {
  const { t } = useTranslation();
  const bookingType = useWatch({
    name: 'airbnbSettings.bookingType',
  });

  const availableValues = optionsByBookingType[bookingType] || [];

  const options = availableValues.map((value) => ({
    label: t(
      `pageProperty.mainSettings.airbnbSettings.guestRequirementsOptions.${value}`,
    ),
    value,
  }));

  return (
    <SelectField
      label={t('pageProperty.mainSettings.airbnbSettings.guestRequirements')}
      name="airbnbSettings.guestRequirements"
      options={options}
      colSmInput={7}
      colSmLabel={5}
    />
  );
};

export default GuestRequirementsField;
